import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { ChatUser } from "../chat/chat.service";
import { tap, catchError } from "rxjs/operators";
import { BaseService } from "../base.service";
import Paho from "paho-mqtt";
import { environment } from "src/environments/environment";
import * as moment from "moment";
@Injectable({
  providedIn: "root",
})
export class MessageService {
  public configuration: ChatConfig;
  public messageServiceURL: string;
  public user: ChatUser;
  private client: Paho.Client;
  private messageQueue = [];
  private isTyping = false;
  public connectionStatusEvent = new BehaviorSubject({});
  public subscribeStatusEvent = new BehaviorSubject({});
  public messageEvent = new BehaviorSubject([]);
  public typingEvent = new BehaviorSubject({});
  public enableChatBox = new BehaviorSubject(false);
  messages = new BehaviorSubject([]);
  public showTypingIndicator = new BehaviorSubject(false);
  maxId = 0;

  public metadata: MessageMetadata;
  public previousMetadata: MessageMetadata;
  private lastMessageIndex: string = "";
  private connected: boolean;
  public scrollToBottom = new BehaviorSubject(false);

  constructor(public baseService: BaseService) {}
  sendMessageFromOther(text: string) {
    const message = {
      message: {
        type: 1,
        text,
        metadata: undefined,
        id: new Date().getTime() + "_" + Math.random(),
      },
      form: undefined,
      state: undefined,
    };
    this.sendMessage(message, true);
  }
  sendTextMessage(text: string) {
    const message = {
      message: {
        type: 1,
        text,
        metadata: undefined,
        id: new Date().getTime() + "_" + Math.random(),
      },
      form: undefined,
      state: undefined,
    };
    this.sendMessage(message);
  }
  updateMessages(messages) {
    const currentValue = this.messages.value;
    let messagesToAdd = [];
    if (currentValue.length > 0) {
      messages.forEach((m) => {
        const found = currentValue.find((msg) => {
          return msg.id === m.id;
        });
        if (!found) {
          messagesToAdd.push(m);
        }
      });
    } else {
      messagesToAdd = messagesToAdd.concat(messages);
    }

    const updatedValue = [...currentValue, ...messagesToAdd];
    this.messages.next(updatedValue);
  }
  ackHealthPlan() {
    const txtMsg =
      "Thank you for personalised health plan. I will follow this.";
    const msgs = this.messages.value;
    if (msgs.length > 0) {
      const lastMessage = msgs[msgs.length - 1] as Message;
      const newMessage = JSON.parse(JSON.stringify(lastMessage)) as Message;
      if (
        lastMessage &&
        lastMessage.content &&
        lastMessage.content.state &&
        lastMessage.content.state.type === "hp_complete"
      ) {
        newMessage.content.message.text = txtMsg;
        newMessage.content.state["type"] = "hp_complete";
        newMessage.content.message.type = 1;
        newMessage.mine = true;
        newMessage.sender = this.user.chatUserId;
        newMessage.content.form = undefined;
        newMessage.content.message.id =
          "" + new Date().getTime() + "_" + Math.random();

        this.sendMessage(newMessage.content);
      }
    }
  }
  submitAnswer(anwser: string) {
    const msgs = this.messages.value;

    if (msgs.length > 0) {
      const lastMessage = msgs[msgs.length - 1] as Message;
      const newMessage = JSON.parse(JSON.stringify(lastMessage)) as Message;

      newMessage.content.message.text = anwser;
      newMessage.content.message.type = 1;
      newMessage.mine = true;
      newMessage.sender = this.user.chatUserId;
      newMessage.content.form = undefined;
      newMessage.content.message.id =
        "" + new Date().getTime() + "_" + Math.random();

      this.sendMessage(newMessage.content);
    }
  }
  loadOldMessage(): Observable<any> {
    const url = `${this.messageServiceURL}?size=30`;

    return this.baseService.get(url).pipe(
      tap((res) => {
        const msgs = this._processGetMessageResponse(res);
        if (res.messages) {
          this.lastMessageIndex = res.messages[res.messages.length - 1].id;
        }

        this.metadata = res.metadata;
        this.previousMetadata = res.metadata;
        this.messages.next([]);
        this.updateMessages(msgs);

        setInterval(() => {
          this.checkAndGetNewMessages();
        }, 5000);
      })
    );
  }
  loadPreviousPageMessage(): Observable<any> {
    if (this.previousMetadata.previousURL === "") {
      return new BehaviorSubject({
        messages: [],
        metadata: {},
      });
    }

    const url = `${environment.serviceURL}${this.previousMetadata.previousURL}`;
    return this.baseService.get(url).pipe(
      tap((res) => {
        const msgs = this._processGetMessageResponse(res);
        this.previousMetadata = res.metadata;
        if (msgs) {
          msgs.reverse().forEach((msg) => {
            setTimeout(() => {
              const updatedValue = [msg, ...this.messages.value];
              this.messages.next(updatedValue);
            }, 800);
          });
        }
      })
    );
  }
  checkAndGetNewMessages() {
    if (this.lastMessageIndex != "") {
      const url = `${this.messageServiceURL}?size=20&minId=${this.lastMessageIndex}`;
      this.baseService.get(url).subscribe((res) => {
        if (res && res.messages) {
          const msgs = this._processGetMessageResponse(res);
          this.lastMessageIndex = res.messages[res.messages.length - 1].id;
          this.metadata = res.metadata;
          this.updateMessages(msgs);
          this.scrollToBottom.next(true);
        }
      });
    }
  }
  _processGetMessageResponse(res) {
    let messages = [];

    if (res.messages !== null) {
      let firstMsgTime = null;
      res.messages.forEach((msg) => {
        msg.mine = this.configuration.username === msg.sender;

        if (firstMsgTime == null) {
          firstMsgTime = parseInt(moment(msg.createdAt).format("YYYYMMDD"));
        } else {
          const currentTime = parseInt(
            moment(msg.createdAt).format("YYYYMMDD")
          );
          if (currentTime !== firstMsgTime) {
            const ob = {
              content: {
                message: { type: -2, text: "" + currentTime } as ChatMessage,
              } as MessageContent,
            } as Message;
            messages = messages.concat(ob);
            firstMsgTime = currentTime;
          }
        }
        messages = messages.concat(msg);
      });
      res.messages = messages;
    }

    return messages;
  }
  connect(user: ChatUser, websocket: boolean) {
    const chatConfig = {
      host: "staging.ws.zyla.in",
      port: 15673,
      vhost: "/ws",
      clientId: "_" + user.externalUserIdSt + "_" + Math.random(),
      room: "/user/" + user.chatRoom,
      username: "" + user.externalUserIdSt,
      password: user.chatToken,
    };
    this.configuration = chatConfig;
    this.messageServiceURL =
      `${environment.serviceURL}/v1/messaging/messages/` + user.chatRoom;
    this.user = user;

    if (websocket) {
      this._initClient();
      this._connect();
    }
    this.loadOldMessage().subscribe((res) => {
      this.scrollToBottom.next(true);
    });
  }
  _initClient() {
    var that = this;
    this.client = new Paho.Client(
      this.configuration.host,
      this.configuration.port,
      this.configuration.vhost,
      this.configuration.clientId
    );
    this.client.disconnectedPublishing = true;
    (this.client.onMessageArrived = (message) => {
      const msg = JSON.parse(message.payloadString);
      const content = msg.content;
      if (msg.event === "message.send") {
        const msgContent = {
          id: "",
          roomId: msg.toExchange.split("/")[2],
          sender: msg.sender,
          exchange: msg.toExchange,
          content: msg.content,
          createdAt: Date.now(),
          mine: msg.sender === this.configuration.username,
        };
        this.showTypingIndicator.next(true);
        setTimeout(() => {
          that.updateMessages([msgContent]);
          this.showTypingIndicator.next(false);
        }, 2000);
      } else if (msg.event === "typing") {
        if (msg.sender !== this.configuration.username) {
          this.typingEvent.next(content);
        }
      } else if (msg.event === "system") {
        if (content.state && content.state["type"] === "enable_chat") {
          this.enableChatBox.next(true);
        }
      }
    }),
      (this.client.onConnectionLost = (error) => {
        this.connectionStatusEvent.next({ status: "F", result: error });
      });
  }
  typingIndicator(): Observable<boolean> {
    return this.showTypingIndicator.asObservable();
  }
  _connect() {
    this.client.connect({
      userName: this.user.chatUserId,
      password: this.user.chatToken,
      useSSL: true,

      reconnect: true,
      onSuccess: () => {
        this.connected = true;
        this.subscribe();
        if (this.messageQueue.length > 0) {
          this.messageQueue.forEach((msg) => {
            msg.sender = this.configuration.username;
            msg.toExchange = "/user/" + this.user.chatRoom;
            this._publishMessage(msg);
          });
          this.messageQueue = [];
        }
        this.connectionStatusEvent.next({ status: "S", result: this.client });
      },
      onFailure: (error) => {
        console.log(error);
        this.connectionStatusEvent.next({ status: "F", result: error });
      },
    });
  }

  sendMessage(message: MessageContent, fromTheir: boolean = false) {
    const ob = {
      content: message,
      sendAs: this.user.chatUserId,
    } as Message;
    if (fromTheir) {
      ob.sendAs = "chat-worker";
    }
    this._publishMessage(ob).subscribe((res) => {
      const msgs = this._processGetMessageResponse({ messages: [res] });
      this.lastMessageIndex = res.id;
      this.updateMessages(msgs);
      this.scrollToBottom.next(true);
    });
  }
  _publishMessage(ob: Message): Observable<Message> {
    const url = `${this.messageServiceURL}`;
    return this.baseService.put(url, ob);
    // this.client.publish(
    //   "/user/" + this.user.chatRoom,
    //   JSON.stringify(ob),
    //   0,
    //   false
    // );
  }

  subscribe() {
    this.client.subscribe(`/user/${this.user.chatRoom}`, {
      onSuccess: (obj: any) => {
        this.subscribeStatusEvent.next({ status: "S", result: obj });
      },
      onFailure: (f: any) => {
        this.subscribeStatusEvent.next({ status: "F", result: f });
      },
    });
  }

  typing() {
    if (!this.isTyping) {
      let ob = {
        content: "",
        event: "typing",
        toExchange: this.configuration.room,
        sender: this.configuration.username,
        uuid: new Date().getTime(),
      };

      if (this.client.isConnected()) {
        this.client.publish(
          this.configuration.room,
          JSON.stringify(ob),
          0,
          false
        );
      }
      this.isTyping = true;
      setTimeout(() => {
        this.isTyping = false;
      }, 2000);
    }
  }
  getInformationCard(id): Observable<any> {
    let url = `${environment.apiURL}/feeds/information/${id}`;

    return this.baseService.get(url).pipe(
      tap((res) => {
        if (res) {
          return res;
        }
      }),
      catchError((e) => {
        console.log(e);
        throw e;
      })
    );
  }
}

export interface MessageMetadata {
  maxId: string;
  minId: string;
  nextURL: string;
  previousURL: string;
  refreshURL: string;
  size: number;
}

export interface ChatConfig {
  host: string;
  port: number;
  vhost: string;
  clientId: string;
  room: string;
  username: string;
  password: string;
}

export interface Message {
  id?: string;
  sender: string;
  exchange?: string;
  content: MessageContent;
  mine?: boolean;
  createdAt?: Date;
  sendAs?: string;
}
export interface MessageContent {
  message: ChatMessage;
  form: MessageForm;
  state: {
    type: string;
    id: string;
  };
}

export interface ChatMessage {
  type: number;
  text: string;
  metadata: ChatMessageMetaData;
  id: string;
}

export interface ChatMessageMetaData {
  id?: string;
}

export interface MessageForm {
  type: number;
  options: Array<string>;
}
